export default __webpack_public_path__ + "afc3dff117f2c7f2b40ed8e595f0b35e.png";